import React from 'react';
import cn from '../../lib/cn';

/**
 * The logo's signature motif: a run of navy dots that grow along a curve.
 * Reused as a divider and as ornament beside headings.
 */
export function DotTrail({ count = 6, className, tone = 'ink', reverse = false }) {
  const dots = Array.from({ length: count }, (_, i) => i);
  const palette = {
    ink: 'bg-ink-600',
    gold: 'bg-champagne-300',
    sun: 'bg-sun-400',
    light: 'bg-canvas/70',
  }[tone];

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)} aria-hidden="true">
      {(reverse ? [...dots].reverse() : dots).map((i) => {
        const size = 2 + i * 1.4;
        return (
          <span
            key={i}
            className={cn('rounded-full', palette)}
            style={{ width: `${size}px`, height: `${size}px`, opacity: 0.35 + i * 0.11 }}
          />
        );
      })}
    </span>
  );
}

export default DotTrail;
